import Translate, { useI18n } from '@hydra/common/components/i18n';
import Button from '@hydra/common/components/Button';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.common.white,
    padding: theme.spacing(5),
    marginTop: theme.spacing(3)
  },
  title: {
    fontWeight: theme.typography.fontWeightSemibold
  },
  subTitle: {
    fontSize: theme.typography.fontSizeMedium
  }
}));

function ReviewTeaserNoCritCTA () {
  const classes = useStyles();
  const { locale } = useI18n();
  return (
    <div className={classes.root}>
      <Typography
        variant='h3'
        color='textPrimary'
        className={classes.title}
        paragraph
      >
        <Translate content='teaser_review_no_crit_cta_title' />
      </Typography>
      <Typography
        variant='body2'
        color='textPrimary'
        className={classes.subTitle}
        paragraph
      >
        <Translate content='teaser_review_no_crit_cta_sub_title' />
      </Typography>
      <Button
        variant='contained'
        color='success'
        size='large'
        href={`/${locale}/register/plan/v2pro`}
      >
        <Translate content='teaser_review_cta_start_my_free_trial' />
      </Button>
    </div>
  );
}

export default ReviewTeaserNoCritCTA;
